import React from "react";
import buttonStyles from "../../../styles/UI/buttons.module.css";
import { ButtonVariantType } from "../../../types/buttons";
import { Spinner } from "../Spinner";

const StandardButton = ({
  iconRight,
  iconLeft,
  children,
  variant,
  onClick,
  classes,
  disable,
  width,
  pending
}: {
  iconRight?: React.ReactNode;
  iconLeft?: React.ReactNode;
  children: React.ReactNode | React.ReactNode[];
  variant: ButtonVariantType;
  onClick: (() => void) | ((e: React.MouseEvent) => void);
  classes?: string;
  disable?: boolean;
  width?: string;
  pending?: boolean
}) => {
  const getButtonClassBasedOnVariant = () => {
    switch (variant) {
      case "PRIMARY":
        return buttonStyles.standardButtonPrimary;
      case "SECONDARY":
        return buttonStyles.standardButtonSecondary;
      case "TERTIARY":
        return buttonStyles.standardButtonTertiary;
      case "WHITE":
        return buttonStyles.standardButtonWhite;
    }
  };
  return (
    <button
      disabled={disable}
      onClick={onClick}
      className={`
        ${buttonStyles.standardButton} 
        ${getButtonClassBasedOnVariant()} 
        ${classes && classes}
        ${pending && buttonStyles.standardButtonLoading}
        `}
      style={{ width: width }}
    >
      {iconLeft}
      {pending ? <Spinner width={24} height={24} /> : children}
      {iconRight}
    </button>
  );
};

export default StandardButton;
